<template>
  <div style="display: flex;align-items: center;justify-content: space-between">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item
        v-for="(b,index) in breadcrumb"
        :key="index"
      >
        <span @click="goBack(index+1-breadcrumb.length)" style="cursor: pointer;">{{b.name}}</span>
      </el-breadcrumb-item>
    </el-breadcrumb>
    <div style=""></div>
  </div>
</template>

<script>
    import breadcrumb from '../../util/breadcrumb'
    export default {
        name: "breadcrumb",
        data(){
          return{
            breadcrumb:[],
          }
        },
        created(){
          let urlStr = location.hash;
          if(urlStr.indexOf("#")===0){
            urlStr = urlStr.substring(1)
          }
          let index = urlStr.indexOf("?");
          if(index>=0){
            urlStr = urlStr.substring(0,index)
          }
          for(let b of breadcrumb){
            if(b.path===urlStr){
              this.breadcrumb = b.breadcrumb
            }
          }
        },
        methods:{
          goBack(num){
            this.$router.go(num)
          },
          
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/assembly/breadcrumb.vue